/**
 * Client-side constants cho SSO flow.
 * Accounts không yêu cầu state — chỉ cần redirect_uri.
 */
export const ACCOUNTS_URI =
  process.env.NEXT_PUBLIC_ACCOUNTS_URI ?? 'https://accountsstg.ahamove.com';

/** sessionStorage key cho redirect target sau login. */
export const AUTH_REDIRECT_KEY = 'ahafood_auth_redirect';

/**
 * Build accounts SSO URL — không cần state, accounts tự set cookies sau redirect.
 */
export function buildAccountsSignInUrl(redirectUri: string): string {
  const url = new URL('/sign-in', ACCOUNTS_URI);
  url.searchParams.set('redirect_uri', redirectUri);
  return url.toString();
}

/** Same-origin safe redirect target. */
export function safeRedirectTarget(target: string | null): string {
  if (!target) return '/';
  if (target.startsWith('/') && !target.startsWith('//')) return target;
  try {
    const url = new URL(target);
    if (url.origin === window.location.origin) return url.pathname + url.search;
  } catch {
    /* ignore */
  }
  return '/';
}
